
<div class="wid-modal-as-tooltip-inner"
     (click)="close()"
     [innerHTML]="data.content|nl2br">
</div>
